import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, ModalCloseButton, ModalFooter, ModalHeader, ModalTitle } from '@tryhackme/thm-ui-components';
import { WarningInfoBox } from '../warning-info-box';
import { ModalLayoutProps } from './modal.types';
import { StyledIcon, StyledModalTitle, StyledWarningBoxWrapper } from './modal.styles';
export const ModalLayout = ({
  triggerText,
  modalTitleText,
  children,
  closeButtonText,
  actionButtonText,
  warnBoxText,
  showWarnBox = true,
  handleCloseButtonAction,
  handleActionButton,
  open,
  openChange,
  actionButtonColor = 'primary',
  actionButtonVariant = 'solid',
  triggerButtonColor = 'primary',
  triggerButtonVariant = 'solid',
  triggerElement,
  isTriggerButtonDisabled = false,
  showTriggerElement = true,
  triggerButtonIcon,
  actionElement,
  customHeaderIcon
}: ModalLayoutProps) => <Modal open={open} onOpenChange={openChange} isSmall {...showTriggerElement && {
  triggerElement: triggerElement ?? <Button isDisabled={isTriggerButtonDisabled} variant={triggerButtonVariant} color={triggerButtonColor}>
          {triggerButtonIcon && <FontAwesomeIcon icon={triggerButtonIcon} />}
          {triggerText}
        </Button>
}} data-sentry-element="Modal" data-sentry-component="ModalLayout" data-sentry-source-file="modal.tsx">
    <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="modal.tsx">
      <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="modal.tsx">
        {customHeaderIcon ?? <StyledIcon icon={faCircleQuestion} />}
        <StyledModalTitle data-sentry-element="StyledModalTitle" data-sentry-source-file="modal.tsx">{modalTitleText}</StyledModalTitle>
      </ModalTitle>
    </ModalHeader>

    {children}

    {showWarnBox && <StyledWarningBoxWrapper>
        <WarningInfoBox warningText={(warnBoxText as string)} />
      </StyledWarningBoxWrapper>}

    <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="modal.tsx">
      <ModalCloseButton text={closeButtonText} handleCloseButtonAction={handleCloseButtonAction} data-sentry-element="ModalCloseButton" data-sentry-source-file="modal.tsx" />
      {actionElement ?? <Button variant={actionButtonVariant} color={actionButtonColor} onClick={handleActionButton}>
          {actionButtonText}
        </Button>}
    </ModalFooter>
  </Modal>;